module.exports = "\t<div class=\"form-field select\"> <div class=custom-select> <select ng-model=site.language ng-options=\"lang.code as lang.name for lang in languages\" ng-change=changeLanguage(site.language)> <option value=\"\">Select language</option> </select> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/common/directives/language-switch.html
// module id = 532
// module chunks = 0